/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .stat-container[_ngcontent-%COMP%]{border:1px solid #000;background:#98c4e3}[_nghost-%COMP%]   .stat-container[_ngcontent-%COMP%]   .stat-item[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };
